import { FeatureToggleKey } from "@omni/types/enums/featureToggleKey.enum";
import { cn } from "@omni/utils/styles";

import { Rating } from "@/components/Product/Rating/rating.component";
import { useFeatureToggle } from "@/context/featureToggles.context";

type ReviewsProps = {
    className?: string;
    overallRatingRange: number;
    totalReviewCount: number;
    averageOverallRating: number;
};

const ProductTileReviews = ({
    className,
    overallRatingRange,
    averageOverallRating,
    totalReviewCount
}: ReviewsProps) => {
    const reviewsEnabled = useFeatureToggle(FeatureToggleKey.FEATURE_REVIEWS);

    if (!reviewsEnabled) return null;
    if (totalReviewCount === 0) return null;

    return (
        <div className={cn("tw:flex tw:items-center", className)}>
            <Rating
                value={averageOverallRating}
                max={overallRatingRange}
                size={16}
                className={cn("tw:pr-2 tw:flex tw:items-center")}
            />
            ({totalReviewCount})
        </div>
    );
};

export { ProductTileReviews };
